import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=238ccb49&scoped=true"
import script from "./StatusList.vue?vue&type=script&lang=js"
export * from "./StatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ccb49",
  null
  
)

export default component.exports